<template>
	<div class="flex justify-around">
		<TrustItem
			src="europes-no1-outlet-01.svg"
			:label="labels.trust.seal_1"
			:caption="labels.trust.seal_1_html"
			:info-text="labels.trust.seal_1_text.replace('{country}', country)"
			data-track-element="IconNo1"
			@click.native="sendTracking($event)"
		/>
		<TrustItem
			src="bester-online-shop-glamour.svg"
			:label="labels.trust.seal_2"
			:caption="labels.trust.seal_2_html"
			:info-text="labels.trust.seal_2_text"
			data-track-element="IconNo2"
			@click.native="sendTracking($event)"
		/>
	</div>
</template>

<script>
import TrustItem from "@/components/TrustItem";
import { pushEvent } from "@/services/dataLayerLogin";
import { country } from "@ocm/services/ocm-object";
import labels from "../labels.json";

export default {
	components: {
		TrustItem,
	},
	props: {
		isLogin: { type: Boolean, required: true },
	},
	data() {
		return {
			country,
			labels,
		};
	},
	methods: {
		sendTracking(event) {
			const trackedElement = event?.currentTarget?.dataset?.trackElement;
			pushEvent(this.isLogin ? "LoginLayer" : "RegistrationLayer", trackedElement);
		},
	},
};
</script>
